import React, { FC } from 'react';

import { ExpertCard } from '@catawiki/cata-style';

import { ScrollableList } from '@/shared/components/ScrollableList';

import styles from './Row.module.scss';

export interface Expert {
  mainImage: string;
  url: string;
  name: string;
  expertise: string;
  expertiseInput: string;
  gender: string;
}

interface Props {
  experts?: Expert[];
}

export const Row: FC<Props> = ({ experts = [] }) => (
  <ScrollableList
    data-testid="row"
    itemClassName={styles.item}
    arrowClassName={styles.arrow}
  >
    {experts.map((expert, idx) => {
      const key = idx;
      return (
        <ExpertCard
          key={key}
          mainImage={expert.mainImage}
          url={expert.url}
          name={expert.name}
          expertise={expert.expertise}
        />
      );
    })}
  </ScrollableList>
);
